import { MembershipRole } from '@workingclock/types';
import { z } from 'zod';


export const createOrganizationSchema = z.object({
  name: z.string().min(1).max(120),
  timezone: z.string().min(1).max(64).default('UTC'),
});
export type CreateOrganizationInput = z.infer<typeof createOrganizationSchema>;

export const updateOrganizationSettingsSchema = z.object({
  name: z.string().min(1).max(120).optional(),
  timezone: z.string().min(1).max(64).optional(),
  defaultRate: z.number().min(0).nullable().optional(),
  logoUrl: z.string().url().nullable().optional(),
});
export type UpdateOrganizationSettingsInput = z.infer<typeof updateOrganizationSettingsSchema>;

export const inviteMemberSchema = z.object({
  email: z.string().email(),
  role: z.nativeEnum(MembershipRole),
});
export type InviteMemberInput = z.infer<typeof inviteMemberSchema>;

export const updateMemberRoleSchema = z.object({
  role: z.nativeEnum(MembershipRole),
});
export type UpdateMemberRoleInput = z.infer<typeof updateMemberRoleSchema>;
